export default function getWeatherIcon({ temperatura_min, temperatura_max, probabilidade_chuva }) {
  const diff = temperatura_max - temperatura_min;

  // 1. Neve
  if (temperatura_max <= 4 || temperatura_min <= 1) {
    return {
      alt: "Neve",
      src: "https://res.cloudinary.com/dghjxccks/image/upload/v1763477814/neve_gbn4hq.png",
      bg: "bg-chuva"
    };
  }

  // 2. Tempestade com raios
  if (
    (probabilidade_chuva >= 70 && temperatura_max >= 30) ||
    (probabilidade_chuva >= 60 && diff >= 12)
  ) {
    return {
      alt: "Raios",
      src: "https://res.cloudinary.com/dghjxccks/image/upload/v1763477815/raios_aiswqe.png",
      bg: "bg-chuva"
    };
  }

  // 3. Chuva forte
  if (probabilidade_chuva >= 70) {
    return {
      alt: "Chuva",
      src: "https://res.cloudinary.com/dghjxccks/image/upload/v1763477813/chuva_no8tsg.png",
      bg: "bg-chuva"
    };
  }

  // 4. Pancadas de chuva
  if (probabilidade_chuva >= 40) {
    return {
      alt: "Pancadas de Chuva",
      src: "https://res.cloudinary.com/dghjxccks/image/upload/v1763477815/pancadas_hs6poy.png",
      bg: "bg-chuva"
    };
  }

  // 5. Nublado
  if (probabilidade_chuva >= 20) {
    return {
      alt: "Nublado",
      src: "https://res.cloudinary.com/dghjxccks/image/upload/v1763477814/nuvens_f9qght.png",
      bg: "bg-ceu-nublado"
    };
  }

  // 6. Névoa (variação térmica forte)
  if (probabilidade_chuva < 20 && diff >= 10 && temperatura_max <= 26) {
    return {
      alt: "Nevoa",
      src: "https://res.cloudinary.com/dghjxccks/image/upload/v1763477814/nevoa_iknmib.png",
      bg: "bg-ceu-nublado"
    };
  }

  // 7. Vento (calor seco)
  if (probabilidade_chuva < 20 && temperatura_max >= 32) {
    return {
      alt: "Vento",
      src: "https://res.cloudinary.com/dghjxccks/image/upload/v1763477815/vento_luvnxo.png",
      bg: "bg-ceu-limpo"
    };
  }

  // 8. Sol com poucas nuvens
  if (probabilidade_chuva >= 10) {
    return {
      alt: "Sol com nuvens",
      src: "https://res.cloudinary.com/dghjxccks/image/upload/v1763477815/sol-nuvem_ahpfty.png",
      bg: "bg-raios-sol"
    };
  }

  // 9. Sol limpo
  return {
    alt: "Sol",
    src: "https://res.cloudinary.com/dghjxccks/image/upload/v1763477815/sol_lfsk85.png",
    bg: "bg-ceu-limpo"
  };
}

